import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-digi-result',
  templateUrl: './digi-result.component.html',
  styleUrls: ['./digi-result.component.scss']
})
export class DigiResultComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/digi/digi-result/digi-result.component.ts